module.exports = __webpack_public_path__ + "static/8invgde-85077ef70c729c61089b280476b0f178.gif";